export const updateFavoritesStorage = function () {
    window.removeFavorites();
    const e = document.createElement('script');
    e.type = 'text/javascript';
    e.src = secureBaseURL + 'common/json-favorites.html?callback=addFavoritesToLocalStorage&timestamp=' + (new Date()).getTime();
    document.getElementsByTagName('head')[0].appendChild(e);
};

// In the future we could update this to be a proper type, but I'm not going to right now
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FavData = any;
interface FavObj {
    data?: FavData,
}

function tryToConvertFavDataToLocalStorage(favCookieName: string, data: FavData) {
    const favIds = data.favIds[favCookieName];
    if (favIds) {
        window.favCache[favCookieName] = favIds;
        window.dcLocalStorage.setValue(favCookieName, JSON.stringify(favIds));
    }
}

export const tryToConvertMyGPIdsToLocalStorage = function (data: FavData) {
    const myGPs = data.favIds.myGPs;
    if (myGPs) {
        window.favCache.myGPs = myGPs;
        window.dcLocalStorage.setValue('myGPs', JSON.stringify(myGPs));
    }
};

// @ts-expect-error To allow us to set addFavoritesToLocalStorage on window for JSONP callback.
// I'm not adding it to our global Window interface because our own code should not call it that way.
// It should be imported by other code that needs it.
export const addFavoritesToLocalStorage = window.addFavoritesToLocalStorage = function (obj: FavObj | nullish) {
    if (!obj || !obj.data || !obj.data.favIds) return;

    tryToConvertFavDataToLocalStorage('favProposalIds', obj.data);
    tryToConvertFavDataToLocalStorage('favChallengeIds', obj.data);
    tryToConvertFavDataToLocalStorage('favDonorIds', obj.data);
    tryToConvertFavDataToLocalStorage('favTeacherIds', obj.data);
    tryToConvertFavDataToLocalStorage('favSchoolIds', obj.data);
    tryToConvertFavDataToLocalStorage('favSearchURLs', obj.data);
    tryToConvertMyGPIdsToLocalStorage(obj.data);

    // add favCookiesSet cookie -- indicates to header if the user has any favorites
    window.createCookie('favCookiesSet', (obj.data.favIds.favCookiesSet) ? 'true' : 'false', 365);

    // add hasViewableGPs cookie -- indicates to header if user has any giving pages (active or archived)
    window.createCookie('hasViewableGPs', (obj.data.favIds.hasViewableGPs) ? 'true' : 'false', 365);

    $(document).trigger('updateFavoritesStorage');
};

/**
 * example of usage
 * $.when(getFavList("myGPs")).then(function(favList) { alert(favList); });
 *
 * There might not be much value in have this use Deferred now that it makes sync localstorage calls,
 * but I'm leaving the existing API in place.
 */
export const getFavList = function (favType: string) {
    const favList = window.favCache[favType];
    if (favList != null) {
        return favList;
    } else {
        return $.Deferred(function (defer) {
            const value = window.dcLocalStorage.getValue(favType);
            if (value != null && value != '') {
                window.favCache[favType] = value;
            } else {
                window.favCache[favType] = [];
            }
            defer.resolve(window.favCache[favType]);
        });
    }
};
